import { useEffect } from "react";

/**
 * Adds "in" class to elements with .reveal or .reveal-clip once they
 * enter the viewport. Also applies scroll-based parallax via [data-parallax].
 */
export default function ScrollReveal() {
  useEffect(() => {
    const revealEls = document.querySelectorAll(".reveal, .reveal-clip");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );
    revealEls.forEach((el) => io.observe(el));

    const parallaxEls = document.querySelectorAll("[data-parallax]");
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const sy = window.scrollY;
        parallaxEls.forEach((el) => {
          const speed = parseFloat(el.getAttribute("data-parallax")) || 0.1;
          const rot = parseFloat(el.getAttribute("data-rot") || "0");
          el.style.transform = `translate3d(0, ${sy * speed}px, 0) rotate(${sy * rot}deg)`;
        });
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      io.disconnect();
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return null;
}
